import { h } from "preact";

import { classNames } from "../helpers";
import mapboxApi from "../api/mapbox";
import { useEffect, useState } from "preact/hooks";
import { sendError } from "../errors";

export default function DisplayLocation(props) {
  const [location, setLocation] = useState(null);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [created, setCreated] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);

  let map;

  function initMarkers() {
    if (!initialized && location && window.L) {
      const markerIcon = L.icon({
        iconSize: [25, 41],
        iconAnchor: [10, 41],
        popupAnchor: [2, -40],
        // specify the path here
        iconUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png",
        shadowUrl:
          "https://unpkg.com/leaflet@1.5.1/dist/images/marker-shadow.png",
      });

      setInitialized(true);
      const marker = L.marker(location.latLng, {
        icon: markerIcon,
      }).addTo(map);
      if (location.zipcode) {
        marker.bindPopup(
          `<b>${location.name}</b><br/><div class="address-line">${[
            location.street,
            `${location.zipcode} ${location.city}`,
          ].join(", ")}</div>`
        );
      } else {
        marker.bindPopup(
          `<b>${location.name}</b>
           <br/>
           <div class="address-line">${location.street}</div>`
        );
      }
      marker.addEventListener("click", () => {
        setSelectedLocation(location);
      });
    }
  }

  async function createMap() {
    if (!location || created || !scriptLoaded) return;

    setCreated(true);
    map = L.map("mapid");

    L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
      {
        attribution:
          'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 18,
        id: "mapbox/streets-v11",
        tileSize: 512,
        zoomOffset: -1,
        accessToken:
          "pk.eyJ1IjoiZ2Vvcmctbmlvb21pIiwiYSI6ImNrcHdhZDR5YTBid3oydXRjOWcxMXg2MDcifQ.pVbNtKCxJSVDP2J0W6YR2w",
      }
    ).addTo(map);
    initMarkers();
    map.setView(location.latLng, 13);
  }

  async function handleLoaded() {
    setScriptLoaded(true);

    // createMap();
  }

  useEffect(() => {
    if (scriptLoaded && !initialized && location) {
      createMap();
    }
  }, [initialized, scriptLoaded, location]);

  useEffect(async () => {
    if (props.location.lat && props.location.lng) {
      setLocation({
        ...props.location,
        latLng: [props.location.lat, props.location.lng],
      });

      createMap();
    } else if (props.location.street) {
      const result = await mapboxApi.lookupAddress(
        `${props.location.street}, ${props.location.zipcode} ${props.location.city}, ${props.location.country}`
      );
      if (result) {
        setLocation({
          ...props.location,
          latLng: [result.lat, result.lng],
        });

        createMap();
      } else {
        const err = new Error("Address could not be loaded from Mapbox API.");
        sendError(err, { location: props.location });
      }
    } else {
      const err = new Error("No location or address provided.");
      sendError(err, { location: props.location });
    }
  }, []);

  // Show only if we have a location with actual longitude and latitude
  const display = location ? "block" : "none";

  return (
    <div class={classNames(props.class)}>
      <link
        rel="stylesheet"
        href="https://unpkg.com/leaflet@1.7.1/dist/leaflet.css"
        integrity="sha512-xodZBNTC5n17Xt2atTPuE1HxjVMSvLVW9ocqUKLsCC5CXdbqCmblAshOMAS6/keqq/sMZMZ19scR4PsZChSR7A=="
        crossorigin=""
      />
      <script
        src="https://unpkg.com/leaflet@1.7.1/dist/leaflet.js"
        integrity="sha512-XQoYMqMTK8LvdxXYG3nZ448hOEQiglfqkJs1NOQV44cWnUrBc8PkAOcXy20w0vlaXaVUearIOBhiXZ5V3ynxwA=="
        crossorigin=""
        onload={handleLoaded}
      ></script>
      {props.title && (
        <h4
          class="t-subtitle2 t-subtitle2--margin"
          style={`display: ${display}`}
        >
          {props.title}
        </h4>
      )}
      <div id="mapid" style={`height: 500px; display: ${display}`}></div>
    </div>
  );
}
